import { render, staticRenderFns } from "./hospitalStatistics.vue?vue&type=template&id=3afc1836&scoped=true&"
import script from "./hospitalStatistics.vue?vue&type=script&lang=js&"
export * from "./hospitalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./hospitalStatistics.vue?vue&type=style&index=0&id=3afc1836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc1836",
  null
  
)

export default component.exports